import { array, number, partial, string } from 'io-ts/Decoder';

import { Id as TransactionId } from '../../../../transaction/Id';
import { Area } from '../../../../ui/geometry/Area';

export const Request = partial({
	text: string,
	areas: array(Area),
	textDifferenceIds: array(number),
	transactionIds: array(TransactionId),
});
